import api from "./index.js";

export function getCategoriess() {
    return api.get("/api/categories");
}

export function getQuestionCategories() {
    return api.get("/api/questionCategories");
}
